<template>
  <v-app v-if="ready">
    <toolbar @click-menu="drawer = !drawer" v-if="!$route.meta.noMenu" />
    <drawer v-model="drawer" v-if="!$route.meta.noMenu" />
    <Content />
    <v-snackbar v-model="toast.show" v-bind="toast">{{
      toast.message
    }}</v-snackbar>
  </v-app>
</template>

<script>
import Toolbar from './components/Toolbar.vue'
import Drawer from './components/Drawer.vue'
import Content from './components/Content.vue'
import { Auth } from './service'

export default {
  name: 'App',
  components: {
    Toolbar,
    Drawer,
    Content
  },
  async created() {
    this.$store.watch(
      state => state.toast.show,
      show => {
        if (show) {
          this.toast = { ...this.$store.state.toast }
          this.$store.dispatch('toast', { show: false, message: '' })
        }
      }
    )

    await Auth.getTimeOffset().catch(() => null)
    this.ready = true
  },
  data() {
    return {
      drawer: true,
      ready: false,
      toast: {}
    }
  },
  computed: {}
}
</script>
